
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import advancedCardDescriptor from './DatasetManagementAdvancedCardDescriptor.json'
import DatasetScheduler from './DatasetManagementScheduler.vue'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'
import InputSwitch from 'primevue/inputswitch'
import { mapState } from 'vuex'

export default defineComponent({
    components: { Card, InputSwitch, Checkbox, KnValidationMessages, DatasetScheduler },
    props: {
        selectedDataset: { type: Object as any },
        transformationDataset: { type: Object as any },
        schedulingData: { type: Object as any }
    },
    computed: {
        ...mapState({
            user: 'user'
        }),
        disablePersist() {
            if (this.dataset['pars'] && this.dataset['pars'].length > 0) {
                return true
            }
            return false
        },
        isAbleToSeeIsScheduledToolbar(): Boolean {
            return this.user.functionalities.includes('SchedulingDatasetManagement') && this.dataset.isPersisted
        },
        isAbleToSeeDatasetScheduler(): Boolean {
            return this.user.functionalities.includes('SchedulingDatasetManagement') && this.dataset.isPersisted && this.dataset.isScheduled
        }
    },
    emits: ['touched'],
    data() {
        return {
            v$: useValidate() as any,
            advancedCardDescriptor,
            dataset: {} as any,
            testInput: 'testinput',
            testCheckbox: true,
            isTransformable: false
        }
    },
    created() {
        this.dataset = this.selectedDataset
        this.isDatasetTransformable()
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
            this.isDatasetTransformable()
        }
    },
    validations() {
        const transformationFieldsRequired = (value) => {
            return !this.isTransformable || value
        }
        const persistFieldsRequired = (value) => {
            return !this.dataset.isPersisted || value
        }
        const customValidators: ICustomValidatorMap = {
            'transformable-field-required': transformationFieldsRequired,
            'persist-field-required': persistFieldsRequired
        }
        const validationObject = {
            dataset: createValidations('dataset', advancedCardDescriptor.validations.advancedTab, customValidators)
        }
        return validationObject
    },
    methods: {
        isDatasetTransformable() {
            if (this.dataset.trasfTypeCd && this.dataset.trasfTypeCd == this.transformationDataset.VALUE_CD) {
                this.isTransformable = true
            } else {
                this.isTransformable = false
            }
        },
        setTransformationType() {
            if (this.isTransformable) {
                this.dataset.trasfTypeCd = this.transformationDataset.VALUE_CD
            } else {
                this.dataset.trasfTypeCd ? (this.dataset.trasfTypeCd = '') : null
                this.dataset.pivotColName ? (this.dataset.pivotColName = '') : null
                this.dataset.pivotColValue ? (this.dataset.pivotColValue = '') : null
                this.dataset.pivotIsNumRows ? (this.dataset.pivotIsNumRows = '') : null
                this.dataset.pivotRowName ? (this.dataset.pivotRowName = '') : null
            }
        }
    }
})
